import withRequiredAuth from '../../HOC/withRequiredAuth';
import Settings from './Settings';

export default withRequiredAuth(Settings);
